import React from 'react';

import { RibbonItemIcon } from '../../Blocks/Ribbon/RibbonItemIcon.csharp';

interface RibbonItemProps {
    icon?: RibbonItemIcon;
    size: 'small' | 'big';
    text: string;
}

export const RibbonItem = ({ icon, size, text }: RibbonItemProps) => {
    return (
        <span className={`RibbonItem RibbonItem--${size}`}>
            {icon !== undefined && <span className={`RibbonItem__Icon RibbonItem__Icon--${RibbonItemIcon[icon]}`} aria-hidden />}
            <span className="RibbonItem__Text">{text}</span>
        </span>
    );
};
